const RR_Form_Version = 3.73;
const rr_currentUrl = window.location.host;
const fullUrl = window.location.href;
const pageIsInThemeEditorMode = !fullUrl.includes('/editor');
const pageIsInLiveMode = !pageIsInThemeEditorMode;
let CBM_SERVER_URL = '';
let CBM_ALTERNATIVE_SERVER_URL = '';
let CBM_SERVER_CODE = '';

if (fullUrl.includes('develop=true')) {
  CBM_SERVER_URL = 'https://vps-lamp.reelrocktour.com:3700'; 	// develop mode
  CBM_ALTERNATIVE_SERVER_URL = 'https://vps-lamp.reelrocktour.com:3700';
	CBM_SERVER_CODE = 'DEV';
} else
if (rr_currentUrl.startsWith('localhost') || rr_currentUrl.startsWith('127.0.0.1')) {
  CBM_SERVER_URL = 'http://127.0.0.1:3300';
  CBM_ALTERNATIVE_SERVER_URL = 'http://127.0.0.1:3700';
	CBM_SERVER_CODE = 'LOC';
} else {
  CBM_SERVER_URL = 'https://main-vps.reelrocktour.com:3300';
  CBM_ALTERNATIVE_SERVER_URL = 'https://vps-lamp.reelrocktour.com:3300';
	CBM_SERVER_CODE = 'PRO';
} 


window.onload = () => {

  document.getElementById('cashback-form-button').onclick = () => uploadTicket();
  const storeNameAnchor = document.querySelector('.Footer__StoreName');
  storeNameAnchor.textContent += " | " + CBM_SERVER_CODE + " " + RR_Form_Version;
  console.info(" CBM Mode & Version " + CBM_SERVER_CODE + " " + RR_Form_Version);
  pageOpened(getEmailFromUrl());

}

function makeRequest(url, method, data) {
  const headers = new Headers();
  const isFormData = data instanceof FormData;

  if (!isFormData) {
    headers.append("Content-Type", "application/json");
  }

  const config = {
    method: method,
    headers: headers,
    redirect: "follow",
  };

  if (method == "GET") {
    url += "?" + new URLSearchParams(data).toString();
  } else {
    if (isFormData) {
      config.body = data;
    } else {
      config.body = JSON.stringify(data);
    }
  }
  return fetch(url, config)
    .then((response) => {
      if (response.status >= 400) throw new Error("ERROR AL CONSULTAR " + url);
      return response.json()
    })
}

async function tryRequestOnMainAndAltenativeServer(url, method, data, retryNumber = 1){
  try {
    return await makeRequest(CBM_SERVER_URL + url, method, data);
  } catch (errorOnMainServer) {
    if (retryNumber <= 2) {
      return await tryRequestOnMainAndAltenativeServer(url, method, data, ++retryNumber);
    } else {

      try {
        return await makeRequest(CBM_ALTERNATIVE_SERVER_URL + url, method, data);  
      } catch (errorOnAlternativeServer) {
        showModal('Sorry for the inconvenience', 'Our site is experiencing a high volume of traffic. Please try again in one hour.', true);
      }

    }
    
  }
}

async function uploadTicket() {
  const form = document.getElementById('cashback-form');
  
  if (form.checkValidity()) {
    const data = new FormData();
    const preferredRefundMethod_el = document.querySelector('input[name="preferedRefundMethods__name"]:checked');
    const alternateRefundMethod_el = document.querySelector('input[name="alternateRefundMethods__name"]:checked');
    
    data.append('event_date', document.getElementById('showDate').value );
    data.append('event_venue', document.getElementById('showVenue').value );
    data.append('image', document.getElementById('imageUpload').files[0]);
    data.append('email', document.getElementById('shopifyEmail').value);
    data.append('prefered_refund_method', preferredRefundMethod_el.value);
    data.append('alternate_refund_method', alternateRefundMethod_el ? alternateRefundMethod_el.value : '');
    data.append('paypal_email', document.getElementById('paypalEmail').value);

    showModal("Sending information", '<div class="spinner-loader"></div>', false);
    const response = await tryRequestOnMainAndAltenativeServer('/cashback', 'PUT', data);
    if (response.reply === 'ok') {
      showModal('Success!', 'We will process your rebate within the next 3-4 weeks.');
    } else {
      showModal('Heads up!', response.message);
    }
  }
}

async function pageOpened(email) {

  if (!email) {
    return askForEmail();
  }
  
  const response = await tryRequestOnMainAndAltenativeServer('/cashback', 'POST', { email: email });
  if (response.reply === "customer-order-found") {

    const refundMethods = getRefundMethodsByAssessment(response.refund_assessment, response.monthly_payment);
    
    document.getElementById('refundMethodsMessage').innerHTML = refundMethods.message;
    setUpPaymentOptions(refundMethods);
		window.scrollTo(0,600);
  } else {
    askForEmail('Something happened', response.message + ' Please enter the email associated with your Reel Rock purchase:');
  }

  document.getElementById('shopifyEmail').value = email;
  document.getElementById('paypalEmail').value = response.paypalEmail || '';
  document.getElementById('cashback-form').style.display = 'block';
  document.getElementById('form-spinner-loader').style.display = 'none';
}

function getRefundMethodsByAssessment(refundAssessment, monthlyPayment) {
  let refundMethodMessage = '';
  let refundMethod = [];
  let onRefundMethodChange;

  const ON_NON_REFUNDABLE_METHOD_CHANGE = function() {
    if (this.value.startsWith('PAY PAL')){
      askForPaypalEmail();
    } else {
      hidePaypalEmail();
    }
  };

  const ON_REFUNDABLE_METHOD_CHANGE = (alternateRefundMethods) => function() { 

    const alternativeMethodsContainer_el = document.getElementById('alternateRefundMethods_container');
    const alternativeMethos_el = document.getElementById('alternateRefundMethods');
    alternativeMethodsContainer_el.style.display = 'none';
    alternativeMethos_el.innerHTML = '';
    hidePaypalEmail();

    if (this.value.startsWith('SHOPIFY REFUND')) {
      alternativeMethodsContainer_el.style.display = 'block';
      
      setUpPaymentOptions({
        options: alternateRefundMethods,
        onchange: function() {
            if (this.value.startsWith('PAY PAL')){
              askForPaypalEmail();
            } else {
              hidePaypalEmail();
            }
          }
        },
        'alternateRefundMethods'
      );	
   
    } else if (this.value.startsWith('PAY PAL')){
      askForPaypalEmail();
    }
    
  };


    
  // REFUND OPTIONS - Monthly users
  const SKIP_BILLING_REFUND_OPTION = { name: 'SKIP BILLING|2', description: `Your next two monthly billing cycles are free ($${monthlyPayment * 2} value)` };

  const GIFT_CARD_REFUND_OPTION_15 = { name: 'STORE CREDIT|15', description: '$15 in Store Credit - No restrictions' };
  const PAYPAL_REFUND_OPTION_13 = { name: 'PAY PAL|13', description: '$13 PayPal' };
  

  // REFUND OPTIONS - Yearly/Gift users
  const GIFT_CARD_REFUND_OPTION_20 = { name: 'STORE CREDIT|20', description: '$20 in Store Credit - No restrictions' };
  const PAYPAL_REFUND_OPTION_15 = { name: 'PAY PAL|15', description: '$15 PayPal' };
  

  // REFUND OPTIONS - All users
  const SHOPIFY_REFUND_10 = {name: 'SHOPIFY REFUND|10', description: '$10 direct refund'};
	const WAIT_FOR_OTHER_OPTIONS = {name: 'WAIT FOR OPTIONS|0', description: 'I would rather wait for other options like: Debit/Credit card deposit, Venmo, etc.' }

  // MESSAGES - All users
  const REFUNDABLE_MESSAGE = 'Please provide your preferred rebate method:';
  const NON_REFUNDABLE_MESSAGE = 'Unfortunately there is an issue that prevents a direct refund to your account. <br>Please select another rebate option:';

  if (refundAssessment === 'REFUNDABLE-MONTHLY') {
    refundMethodMessage = REFUNDABLE_MESSAGE;
    refundMethod = [
      SKIP_BILLING_REFUND_OPTION,
      GIFT_CARD_REFUND_OPTION_15,
      PAYPAL_REFUND_OPTION_13,
      SHOPIFY_REFUND_10,
    ];
    onRefundMethodChange = ON_REFUNDABLE_METHOD_CHANGE([
      SKIP_BILLING_REFUND_OPTION,
      GIFT_CARD_REFUND_OPTION_15,
      PAYPAL_REFUND_OPTION_13,
			WAIT_FOR_OTHER_OPTIONS
    ]);
  } else if (refundAssessment === 'NON-REFUNDABLE-MONTHLY') {
    refundMethodMessage = NON_REFUNDABLE_MESSAGE;
    refundMethod = [
      SKIP_BILLING_REFUND_OPTION,
      GIFT_CARD_REFUND_OPTION_15,
      PAYPAL_REFUND_OPTION_13,
			WAIT_FOR_OTHER_OPTIONS
    ];
    onRefundMethodChange = ON_NON_REFUNDABLE_METHOD_CHANGE;
  } else if (refundAssessment === 'REFUNDABLE-ANNUAL-OR-GIFT' || refundAssessment === 'REFUNDABLE-MONTHLY-INACTIVE') {
    refundMethodMessage = REFUNDABLE_MESSAGE;
    refundMethod = [
      GIFT_CARD_REFUND_OPTION_20,
      PAYPAL_REFUND_OPTION_15,
      SHOPIFY_REFUND_10,
    ];
    onRefundMethodChange = ON_REFUNDABLE_METHOD_CHANGE([
      GIFT_CARD_REFUND_OPTION_20,
      PAYPAL_REFUND_OPTION_15,
			WAIT_FOR_OTHER_OPTIONS
    ]);
  } else if (refundAssessment === 'NON-REFUNDABLE-ANNUAL-OR-GIFT' || refundAssessment === 'NON-REFUNDABLE-MONTHLY-INACTIVE'){
    refundMethodMessage = NON_REFUNDABLE_MESSAGE;
    refundMethod = [
      GIFT_CARD_REFUND_OPTION_15,
      PAYPAL_REFUND_OPTION_13,
			WAIT_FOR_OTHER_OPTIONS
    ];
    onRefundMethodChange = ON_NON_REFUNDABLE_METHOD_CHANGE;
  }
  return {
    options: refundMethod,
    message: refundMethodMessage,
    onchange: onRefundMethodChange
  }

}

function  askForPaypalEmail() {
  document.getElementById('paypalEmail_container').style.display = 'block';
}

function hidePaypalEmail() {
  document.getElementById('paypalEmail_container').style.display = 'none';
}

function askForEmail(title='', label='Enter the email address associated with your Reel Rock purchase:') {
  const action = `
    const form = document.getElementById('cashback-email-form');
    if (form.checkValidity()) {
      closeModal(); 
      pageOpened(document.getElementById('cashback-email').value);
    }
  `;
  const button = `
    <button class="Button Button--primary" onclick="${action}" style="padding:7px;">Submit</button>
  `;
  const emailInput = `
      <div style="background-color: transparent;">
        <form onsubmit="return false" id='cashback-email-form'>
          <label for="cashback-email">${label} </label>
          <br>
          <input id="cashback-email" type="email" name="cashback-email" style="width:250px; margin-top: 8px; margin-bottom:8px;">
          <div>
            ${button}
          </div>
        </form>
      </div>
  `;
  showModal(title, emailInput, false);
}

function fromHTMLStringToElement(htmlString) {
  const template = document.createElement('template');
  template.innerHTML = htmlString.trim();
  return template.content.firstChild;
}

function getEmailFromUrl() {
  let email = '';
  const urlSearchParams = new URLSearchParams(window.location.search);
  const AES_encodingKey = urlSearchParams.get('AES_Encrypted');
  
  if (AES_encodingKey == '769IlI3MX8942435') {
    const data = urlSearchParams.get('data');
    email = atob(data);
  } else {
    email = urlSearchParams.get('email');
  }
  
  return email;
}

function showModal(modalTitle, modalContent, showButton=true) {
  document.getElementById('modal-alert-title').innerHTML = modalTitle;
  document.getElementById('modal-alert-content').innerHTML = modalContent;
  if (showButton) {
    document.getElementById("modal-button-primary").style.display = "block";    
  } else {
    document.getElementById("modal-button-primary").style.display = "none";    
  }
  document.getElementById("modal-alert").style.display = "block";
}

function setUpPaymentOptions(refundMethod, elementId = 'preferedRefundMethods') {
  const checkboxContainer = document.getElementById(elementId);
  checkboxContainer.innerHTML = '';
  refundMethod.options.forEach(option => {
      const label = option.description;
			const inputId = elementId + '_' + option.name.replace(' ','_').replace('|','_');
      const value = option.name;

      const checkbox = fromHTMLStringToElement(`
        <div class="input-group">
          <input id="${inputId}" type="radio" name="${elementId}__name" value="${value}" required>
          <label for="${inputId}">${label}</label>
        </div>`)
      checkboxContainer.appendChild(checkbox);
  });
  const radios = document.querySelectorAll(`input[type=radio][name="${elementId}__name"]`);
  Array.prototype.forEach.call(radios, function(radio) {
    radio.addEventListener('change', refundMethod.onchange);
  });
}

function closeModal() {
  document.getElementById('modal-alert').style.display = 'none';
}

function redirectToFAQ() {
  window.location.href = 'https://reelrocktour.com/pages/cash-back-promo-help-faq';
}
